import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { HomeIcon, BookOpenIcon, UsersIcon, CalendarIcon, ShoppingBagIcon, HeartIcon, BookIcon, LayoutDashboardIcon, PlusIcon, PaletteIcon, TruckIcon, CompassIcon } from 'lucide-react';
import ServicesPopup from './ServicesPopup';
import { useDarkClasses } from '../../hooks/useDarkClasses';
import { useBrand } from '../../hooks/useBrand';
interface MobileBottomBarProps {
  isReader: boolean;
  cartItemCount: number;
}
const MobileBottomBar: React.FC<MobileBottomBarProps> = ({
  isReader,
  cartItemCount
}) => {
  const dk = useDarkClasses();
  const {
    theme
  } = useBrand();
  const location = useLocation();
  const navigate = useNavigate();
  const [showServicesPopup, setShowServicesPopup] = useState(false);
  const readerNavItems = [{
    path: '/',
    label: 'Home',
    icon: HomeIcon
  }, {
    path: '/browse',
    label: 'Browse',
    icon: CompassIcon
  }, {
    path: '/events',
    label: 'Events',
    icon: CalendarIcon
  }, {
    path: '/authors',
    label: 'Authors',
    icon: UsersIcon
  }, {
    path: '/my-bookshelf',
    label: 'Bookshelf',
    icon: BookIcon
  }];
  const vendorNavItems = [{
    path: '/vendors/dashboard',
    label: 'Dashboard',
    icon: LayoutDashboardIcon
  }, {
    path: '/manage-listings',
    label: 'Listings',
    icon: BookOpenIcon
  }, {
    path: '/vendors/manage',
    label: 'Create',
    icon: PlusIcon,
    isCreate: true
  }, {
    path: '/orders',
    label: 'Orders',
    icon: TruckIcon
  }, {
    action: () => setShowServicesPopup(true),
    label: 'Services',
    icon: PaletteIcon
  }];
  const navItems = isReader ? readerNavItems : vendorNavItems;
  const getActiveColor = (isActive: boolean) => isActive ? theme.roleAccent[isReader ? 'reader' : 'vendor'].navActive : dk.textMuted;
  return <>
      <nav aria-label="Primary" className={`fixed bottom-0 left-0 right-0 border-t z-40 md:hidden transition-transform duration-300 ${dk.nav}`} data-id="element-2648" data-mp="218wxreqi6r4k">
        <div className={`grid grid-cols-5 h-[calc(64px+env(safe-area-inset-bottom))] items-start pt-2 pb-[env(safe-area-inset-bottom)] ${theme.chromeBar}`} data-id="element-2649" data-mp="2ayzqddtpq32d">
          {navItems.map((item, index) => {
          const isActive = item.path ? location.pathname === item.path || item.path !== '/' && location.pathname.startsWith(item.path) : location.pathname.startsWith('/services') || location.pathname.startsWith('/talent') || location.pathname.startsWith('/creative');
          // Vendor "Create" button — elevated center action
          if (item.isCreate && item.path) {
            return <Link key={item.path} to={item.path} className="flex flex-col items-center justify-center -mt-3 tap-highlight" data-id="element-2650" data-mp="37oz8nzzo0fy5">
                  <div className={`w-12 h-12 rounded-2xl flex items-center justify-center shadow-lg transition-transform active:scale-90 ${isActive ? theme.secondary.fabActive : theme.secondary.fab}`} data-id="element-2651" data-mp="3cuch529ozeqt">
                    <PlusIcon className={`h-6 w-6 ${theme.secondary.onFab}`} strokeWidth={2.5} data-id="element-2652" data-mp="342265iqz358i" />
                  </div>
                  <span className={`text-[10px] font-semibold mt-1 ${isActive ? theme.secondary.text : dk.textMuted}`} data-id="element-2653" data-mp="2u2jmz4ivznhi">
                    {item.label}
                  </span>
                </Link>;
          }
          // Action button (Services popup)
          if (item.action) {
            return <button key={index} onClick={item.action} className={`flex flex-col items-center justify-center px-2 touch-target tap-highlight active:scale-95 transition-transform ${getActiveColor(isActive)}`} data-id="element-2654" data-mp="jbtj4gqf89ez">
                  <item.icon className="h-6 w-6 mb-0.5" data-id="element-2655" data-mp="hev49o63p7mw" />
                  <span className="text-[10px] font-medium" data-id="element-2656" data-mp="hebq8ijkn3e5">{item.label}</span>
                </button>;
          }
          // Standard nav link
          return <Link key={item.path} to={item.path!} className={`flex flex-col items-center justify-center px-2 touch-target tap-highlight active:scale-95 transition-transform ${getActiveColor(isActive)}`} data-id="element-2657" data-mp="7n7a3fi5tchq" data-mpi={index}>
                <item.icon className="h-6 w-6 mb-0.5" data-id="element-2658" data-mp="2oxej3siw9vl" />
                <span className="text-[10px] font-medium" data-id="element-2659" data-mp="2ncif9qk8ivm">{item.label}</span>
              </Link>;
        })}
        </div>
      </nav>
      <ServicesPopup isOpen={showServicesPopup} onClose={() => setShowServicesPopup(false)} data-id="element-2660" data-mp="3puoc7emd9asc" />
    </>;
};
export default MobileBottomBar;